// extracted by mini-css-extract-plugin
module.exports = {"container":"AppTile_container__3QaCC","title":"AppTile_title__100a7"};